const pointIdGeneratorLink = ($rootScope, clipboard, BoFeaturesService, type) =>
    function ($scope) {
        const trainingTestCases = BoFeaturesService.isFeatureOn('trainingTestCases')

        const generatePointId = function () {
            let prmId = ''
            prmId += Math.trunc(Math.random() * 6)
            let i = 1
            while (i < 12) {
                prmId += Math.trunc(Math.random() * 10)
                i += 1
            }
            const n1 = Number(prmId[3]) +
            Number(prmId[4]) +
            Number(prmId[5]) +
            Number(prmId[6]) +
            Number(prmId[7]) +
            Number(prmId[8]) +
            Number(prmId[9]) +
            Number(prmId[10]) +
            Number(prmId[11]) + 2

            const n2 = 2 + (2 * Number(prmId[11])) + (3 * Number(prmId[10])) +
            (4 * Number(prmId[9])) +
            (5 * Number(prmId[8])) +
            (6 * Number(prmId[7])) +
            (7 * Number(prmId[6])) +
            (8 * Number(prmId[5])) +
            (9 * Number(prmId[4])) +
            (10 * Number(prmId[3]))

            let mod1 = n1 % 11
            let mod2 = n2 % 11
            if ((mod1 === 10) && (mod2 === 10)) {
                mod1 = (mod2 = 9)
            } else if ((mod1 === 10) && (mod2 === 0)) {
                mod1 = 9
                mod2 = 8
            } else if ((mod1 === 10) && (mod2 !== 0)) {
                mod1 = 0
            } else if ((mod1 === 0) && (mod2 === 10)) {
                mod1 = 8
                mod2 = 9
            } else if ((mod1 !== 0) && (mod2 === 10)) {
                mod2 = 0
            }
            const prm = prmId + mod1.toString() + mod2.toString()
            return prm
        }

        $scope.genPrm = function () {
            $scope.prms = {}
            while (Object.keys($scope.prms).length < 3) {
                const prm = generatePointId()
                const lastDigit = prm.slice(-1)
                if (lastDigit === '0') {
                    $scope.prms.error = prm
                } else if ((lastDigit % 2) === 1) {
                    $scope.prms.base = prm
                } else {
                    $scope.prms.hphc = prm
                }
            }
            if (trainingTestCases) {
                $scope.prms.jdd = [
                    { id: '07561794451615', label: 'PDL 1' },
                    { id: '17199276333663', label: 'PDL 2' },
                    { id: '19182633635715', label: 'PDL 3' },
                    { id: '17517076683733', label: 'PDL 4' },
                    { id: '19148914469581', label: 'PDL 5' },
                ]
            } else {
                $scope.prms.jdd = [
                    { id: '07124457230623', label: 'ECRAC (EPRM001)' },
                    { id: '07599565746979', label: 'ECRAC (new)' },
                    { id: '07429956484276', label: 'ECRAC sans SI (EPRM009)' },
                    { id: '07241389182934', label: 'SSCPT' },
                    { id: '16456295207829', label: 'Compteurs multiples' },
                    { id: '07229811759334', label: 'LU sans compteur' },
                    { id: '07407380533645', label: 'LU avec compteur' },
                    { id: '22211432634485', label: 'LU HPHC 2 cadrans' },
                    { id: '21452387805402', label: 'LU HPHC 14 cadrans' },
                    { id: '16164544033104', label: 'MES (terminated)' },
                    { id: '04185238771878', label: 'MES_INTER' },
                    { id: '01175687244451', label: 'FIRST_MES no power' },
                    { id: '21175687244451', label: 'FIRST_MES no calendar' },
                    { id: '11175687244451', label: 'FIRST_MES no calendar, no power' },
                    { id: '16116497817340', label: 'FIRST_MES no calendar, no power, no phasing' },
                    { id: '02379739494987', label: 'Enedis indispo' },
                    { id: '07400144678439', label: 'HPHC CBE 6kVA' },
                    { id: '15204422742712', label: 'Point inexistant (EPRM000)' },
                    { id: '01221997032575', label: 'Dépôt de garantie' },
                    { id: '17470618465399', label: 'PRM délai MES' },
                    { id: '55725127487932', label: 'PRM hors délai MES' },
                    { id: '41469077265008', label: 'PRM délai 1ère MES' },
                    { id: '41808888400272', label: 'PRM hors délai 1ère MES' },
                    { id: '25287120085666', label: 'TEMPO' },
                    { id: '50093001432242', label: 'FIRST_MES GINKO' },
                    { id: '16124457100149', label: 'Catégorie PRO' },
                    { id: '24083630621203', label: 'Point sans date de prochaine releve' },
                    { id: '16166425262021', label: 'Puissance souscrite 0kVA' },
                    { id: '16100289224401', label: 'Calendrier false' },
                    { id: '22100578831891', label: 'BTINFCU4 - BASE' },
                    { id: '19767148985401', label: 'BTINFCU4 - HPHC' },
                    { id: '21485238720154', label: 'BTINFMU4 - HPHC' },
                    { id: '21139218394197', label: 'BTINFMU4 - BASE' },
                    { id: '30001614621233', label: 'C2' },
                    { id: '30002110338314', label: 'C3' },
                    { id: '50000543733051', label: 'C4' },
                    { id: '50039023072726', label: 'C4 - segment INDET' },
                    { id: '50091117195472', label: 'C3 - autoprod' },
                ]
            }
            $scope.prms.selected = { id: 'NA', label: 'PDLs' }
            return $scope.prms
        }

        $scope.prmSelected = function (kindPrm, index) {
            const prms = (kindPrm === 'jdd') ? $scope.prms : $scope.genPrm()
            if (kindPrm === 'jdd') {
                prms.selected = prms.jdd[index]
            }
            const idPrm = (kindPrm === 'jdd') ? prms.selected.id : prms[kindPrm]
            if (idPrm !== 'NA') {
                clipboard.copyText(idPrm)
                return $rootScope.$broadcast('prmSelected', idPrm)
            }
        }

        $scope.genPce = function () {
            $scope.pces = {}
            while (Object.keys($scope.pces).length < 2) {
                const pce = generatePointId()
                const lastDigit = pce.slice(-1)
                if (lastDigit === '0') {
                    $scope.pces.error = pce
                } else {
                    $scope.pces.eligible = pce
                }
            }

            $scope.pces.jdd = [
                { id: '21134947187340', label: 'PDL 1' },
            ]
            $scope.pces.selected = { id: 'NA', label: 'PCEs' }
            return $scope.pces
        }

        $scope.pceSelected = function (kindPrm, index) {
            const pces = (kindPrm === 'jdd') ? $scope.pces : $scope.genPce()
            if (kindPrm === 'jdd') {
                pces.selected = pces.jdd[index]
            }
            const idPrm = (kindPrm === 'jdd') ? pces.selected.id : pces[kindPrm]
            if (idPrm !== 'NA') {
                clipboard.copyText(idPrm)
                return $rootScope.$broadcast('pceSelected', idPrm)
            }
        }

        if (type === 'PRM') {
            $scope.genPrm()
        } else {
            $scope.genPce()
        }
    }


angular.module('unergie.main')
.directive('prmgenerator', ($rootScope, clipboard, BoFeaturesService) =>
    ({
        restrict: 'E',
        scope: {
            isDisabled: '=',
        },
        templateUrl: '/directives/pointIdGenerator/prmgenerator.html',
        link: pointIdGeneratorLink($rootScope, clipboard, BoFeaturesService, 'PRM'),
    })
).directive('smallprmgenerator', ($rootScope, clipboard, BoFeaturesService) =>
    ({
        restrict: 'E',
        scope: {
            isDisabled: '=',
        },
        templateUrl: '/directives/pointIdGenerator/smallprmgenerator.html',
        link: pointIdGeneratorLink($rootScope, clipboard, BoFeaturesService, 'PRM'),
    })
).directive('smallpcegenerator', ($rootScope, clipboard, BoFeaturesService) =>
    ({
        restrict: 'E',
        scope: {
            isDisabled: '=',
        },
        templateUrl: '/directives/pointIdGenerator/smallpcegenerator.html',
        link: pointIdGeneratorLink($rootScope, clipboard, BoFeaturesService, 'PCE'),
    })
)
